// import { AdminSideBar } from "../components/UserSideBar";
import { useState } from 'react';
import { apiFetchAdmin } from '../../../hooks/apiFetch';
import { allProfilesCategories } from "../../../data/CategoriesData"
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEraser } from "@fortawesome/free-solid-svg-icons";
import { AddWorkProfile } from "../../profile/AddWorkProfile";
import { useAdminProfile } from '../../../context/Admins/AdminProfileContext';
import { toast } from "react-toastify";

import profileSampleImg from "../../../assets/defaults/Profile-Sample0.jpg";
import Pagination from "../../../utilities/Pagination";
import DeleteBtn from '../../../components/buttons/DeleteBtn';
import { useTranslation } from 'react-i18next';

export function SettingProfile() {
    const { settingProfileWorks, currentPage, setCurrentPage, settingAllProfileWorks, setSettingAllProfileWorks,
        setSelectedCategory } = useAdminProfile();
    const [error, setError] = useState(null);
    const { t } = useTranslation();



    const ProfileSample = ({ id, imgSrc, imgAlt, imgCat }) => (
        <div className="admin-profile-img col-12 col-md-4 position-relative">
            <DeleteBtn
                handleOnClick={() => handleProfileWorkDelete(id)}
                t={t}
            />

            {/* <button className="btn-masar btn-med-gray text-secondary p-1 rounded position-absolute top-0 end-0 m-2"
                onClick={() => handleProfileWorkDelete(id)}><FontAwesomeIcon icon={faEraser}
                /></button> */}
            <p className="position-absolute bottom-0 start-50 mb-4 p-1 translate-middle-x bg-white w-75 text-center rounded">{imgCat}</p>
            <img crossOrigin="anonymous"
                src={imgSrc ? imgSrc : profileSampleImg}
                alt={imgAlt}
                className="rounded-4 w-100 p-1"
            />
        </div>
    );

    async function handleProfileWorkDelete(id) {
        try {
            await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/works/${id}`, { method: "DELETE" });
            const updatedProfileWorksData = {
                ...settingAllProfileWorks,
                data: {
                    ...settingAllProfileWorks.data,
                    result: settingAllProfileWorks?.data?.result.filter((itme) => itme.id !== id)
                }
            };
            setSettingAllProfileWorks(updatedProfileWorksData);
            toast.warn("تم الحذف بنجاح");
            setTimeout(() => {
                window.location.reload();
            }, 3000);

        } catch (err) {
            setError("هناك مشكلة في الحذف");
        }
    }

    const totalPages = settingProfileWorks?.data?.paginationInfo.totalPagesCount;

    if (error) {
        return <div className="text-center my-4 text-danger">{error}</div>;
    }
    if (!settingProfileWorks) {
        return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    }
    return (<>
        <div className="container my-3 rounded bg-light-gray position-relative p-3">
            <div className='d-flex justify-content-between'>
                <select className="form-select form-select-sm w-auto mb-2" aria-label="books-category"
                    onChange={e => { setSelectedCategory(e.target.value); setCurrentPage(1) }}>
                    <option value="">الكل</option>
                    {allProfilesCategories.map((category, index) =>
                        <option key={index} value={category.en}>{category.ar}</option>
                    )}
                </select>
                <div className="btn-masar d-flex justify-content-center align-items-center rounded-2 bg-white m-2 mt-0 fs-3 p-0 c-darkGray col-2"
                    data-bs-toggle="modal"
                    data-bs-target="#add-work">
                    +
                </div>
            </div>
            <div className="d-flex flex-wrap justify-content-center">
                {settingProfileWorks?.data?.result.map((item) => (
                    <ProfileSample
                        key={item.id}
                        id={item.id}
                        description={item.description}
                        imgSrc={item.thumbnail}
                        imgAlt={`profileWorks_${item.id}`}
                        imgCat={allProfilesCategories.map(cat =>
                            cat.en === item.service?.name ? cat.ar : "")
                        } />
                ))}
            </div>
            {totalPages > 1 &&
                <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages} />
            }
        </div>
        <AddWorkProfile />
    </>
    )
}